import Link from "next/link";
import { useState } from "react";
import Accordion from "react-bootstrap/Accordion";
import Card from "react-bootstrap/Card";
import Badge from "react-bootstrap/Badge";
import Button from "react-bootstrap/Button";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import AccordionCard from "./AccordionCard";
import ListGroup from "react-bootstrap/ListGroup";
import {useTranslation} from "react-i18next";

const PriceProperty = ({ property }) => {
  const { t } = useTranslation('common');

  const [activeKeys, setActiveKeys] = useState(["0"]);

  const handleSelect = (eventKey) => {
    setActiveKeys((prev) =>
      prev.includes(eventKey)
        ? prev.filter((key) => key !== eventKey)
        : [...prev, eventKey]
    );
  };

  const isKeyActive = (eventKey) => activeKeys.includes(eventKey);

  return (
    <Accordion
      defaultActiveKey="0"
      activeKey={activeKeys}
      onSelect={handleSelect}
    >
      {/* Active card */}
      <AccordionCard eventKey="0">
        <Card.Body>
          <div className="d-flex align-items-center justify-content-between">
            <h3 className="h6 card-title pt-1 mb-0">{t("Prix de vente")}</h3>

            <i
              className={`fi-chevron-${
                isKeyActive("0") ? "up" : "down"
              } fs-base text-muted me-1`}
            ></i>
          </div>
        </Card.Body>
        <Accordion.Collapse eventKey="0">
          <Card.Body className="mt-n1 pt-0">
            <div className="d-flex align-items-center justify-content-between">
              <span className="fw-bolder fs-5 card-title mb-0 me-3">
                <i className="fi-cash fs-base text-primary me-1"></i>
                {property?.price}
              </span>
            </div>
            <Accordion
              defaultActiveKey="0"
              activeKey={activeKeys}
              onSelect={handleSelect}
              className="mt-3"
            >
              <AccordionCard eventKey="1">
                <Card.Body className="px-0">
                  <div className="d-flex align-items-center justify-content-between">
                    <div className="d-flex align-items-center">
                      <i className="fi-briefcase text-primary me-2"></i>

                      <h3 className="h6 card-title pt-1 mb-0">{t("Frais et charges d'acquisition")}</h3>
                    </div>

                    <i
                      className={`fi-chevron-${
                        isKeyActive("1") ? "up" : "down"
                      } fs-base text-muted me-1`}
                    ></i>
                  </div>
                </Card.Body>
                <Accordion.Collapse eventKey="1">
                  <Card.Body className="mt-n1 pt-0">
                    <ListGroup as="ul">
                      <ListGroup.Item
                        as="li"
                        className="d-flex align-items-center"
                      >
                        {t("Droits d'enregistrement")}
                        <Badge bg="secondary" className="ms-auto">
                          {property?.registration_fees}
                        </Badge>
                      </ListGroup.Item>
                      <ListGroup.Item
                        as="li"
                        className="d-flex align-items-center"
                      >
                        {t("Droits de la Conservation Foncière")}
                        <Badge bg="secondary" className="ms-auto">
                          {property?.land_conservation_rights}
                        </Badge>
                      </ListGroup.Item>
                      <ListGroup.Item
                        as="li"
                        className="d-flex align-items-center"
                      >
                        {t("Certificat de propriété et droits fixes")}
                        <Badge bg="secondary" className="ms-auto">
                          {property?.certificate_of_ownership_and_fixed_rights}
                        </Badge>
                      </ListGroup.Item>
                      <ListGroup.Item
                        as="li"
                        className="d-flex align-items-center"
                      >
                        {t("Honoraires du notaire (hors taxes)")}
                        <Badge bg="secondary" className="ms-auto">
                          {property?.notary_fees}
                        </Badge>
                      </ListGroup.Item>
                      <ListGroup.Item
                        as="li"
                        className="d-flex align-items-center"
                      >
                        {t("TVA sur honoraires du notaire")}
                        <Badge bg="secondary" className="ms-auto">
                          {property?.VAT_notary_fees}
                        </Badge>
                      </ListGroup.Item>
                      <ListGroup.Item
                        as="li"
                        className="d-flex align-items-center"
                      >
                        {t("Frais de dossiers divers")}
                        <Badge bg="secondary" className="ms-auto">
                          {property?.frais_dossiers_divers}
                        </Badge>
                      </ListGroup.Item>
                    </ListGroup>
                  </Card.Body>
                </Accordion.Collapse>
              </AccordionCard>

              {/* Card */}
              <AccordionCard eventKey="2" className={property?.is_new ? 'd-none' : ''}>
                <Card.Body className="px-0">
                  <div className="d-flex align-items-center justify-content-between">
                    <div className="d-flex align-items-center">
                      <svg
                        width="24"
                        height="24"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 1100 1100"
                        style={{
                          fill: "#11c5d9",
                          marginBottom: -10,
                          stroke: "#11c5d9",
                          strokeWidth: "10",
                        }}
                      >
                        <g id="Logo_9" data-name="Logo 9">
                          <g>
                            <path d="m711.42,193.44L397.79,7.78c-8.59-5.09-18.41-7.78-28.39-7.78s-19.84,2.7-28.44,7.81L27.29,193.94C10.46,203.92,0,222.29,0,241.86v349.12c0,30.78,24.95,55.73,55.73,55.73h133.78c7.56,0,13.68-6.13,13.68-13.68v-39.54c0-7.56-6.13-13.68-13.68-13.68h-122.6V248.23L369.4,68.72l302.46,179.04v332.03h-278.97c-5.27,0-10.51-1.31-15.16-3.78l-19.88-10.56-1.18-.6c-29.76-14.41-63.5-30.73-92.92-60.97-17.45-17.93-20.5-40.14-19.98-55.6.54-16.05,10.32-32.22,21.35-35.31,1.67-.47,3.53-.71,5.51-.71,7.61,0,16.75,3.5,25.09,9.6,5.09,3.72,10.24,8.48,15.75,14.55,10.5,11.56,25.49,18.19,41.14,18.19,15.64,0,30.63-6.63,41.11-18.18,5.52-6.07,10.67-10.83,15.76-14.56,8.33-6.1,17.48-9.59,25.09-9.59,1.98,0,3.84.24,5.51.71,11.03,3.09,20.81,19.26,21.35,35.3.77,23.03-1.92,40.01-17.72,53.49h0c-4.05,3.46-4.54,9.55-1.08,13.6l30.9,36.22c3.46,4.05,9.55,4.54,13.6,1.08h0c38.56-32.9,42.25-74.27,41.16-106.64-.74-21.91-8.09-43.71-20.68-61.37-12.78-17.92-30.35-30.74-49.48-36.1-7.57-2.12-15.51-3.2-23.61-3.2-22.1,0-44.42,7.79-64.56,22.52-5.9,4.32-11.63,9.21-17.37,14.83-5.74-5.62-11.47-10.51-17.37-14.83-20.13-14.73-42.45-22.52-64.55-22.52-8.09,0-16.04,1.08-23.61,3.2-19.13,5.36-36.7,18.18-49.48,36.1-12.6,17.67-19.94,39.46-20.68,61.37-1.36,40.23,12.45,77.35,38.89,104.52,37.58,38.63,78.37,58.4,111.17,74.27l19.37,10.3c14.28,7.59,30.38,11.6,46.55,11.6h290.14c30.78,0,55.73-24.95,55.73-55.73V241.39c0-19.6-10.48-37.98-27.34-47.96Z" />
                          </g>
                        </g>
                      </svg>

                      <h3 className="h6 card-title pt-1 mb-0">
                        {t("Frais de service à la charge de l'acheteur")}
                      </h3>
                    </div>

                    <i
                      className={`fi-chevron-${
                        isKeyActive("2") ? "up" : "down"
                      } fs-base text-muted me-1`}
                    ></i>
                  </div>
                </Card.Body>
                <Accordion.Collapse eventKey="2">
                  <Card.Body className="mt-n1 pt-0">
                    <div className="d-flex align-items-center justify-content-between">
                      <span className="fw-bolder fs-6 text-nowrap me-3">
                        {property?.service_charges_to_be_paid_by_the_buyer}
                      </span>
                    </div>
                  </Card.Body>
                </Accordion.Collapse>
              </AccordionCard>
            </Accordion>
          </Card.Body>
        </Accordion.Collapse>
      </AccordionCard>
    </Accordion>
  );
};

export default PriceProperty;
